import { useEffect, useCallback, useState, useRef } from 'react';

const MS = 200;

export function useEscapeKey(onClose: () => void, open: boolean): void {
  const handler = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    },
    [onClose]
  );
  useEffect(() => {
    if (!open) return;
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, handler]);
}

export function useModalTransition(open: boolean): {
  mounted: boolean;
  visible: boolean;
} {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const t = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    clearTimeout(t.current);
    if (open) {
      setMounted(true);
      t.current = setTimeout(() => setVisible(true), 10);
    } else {
      setVisible(false);
      t.current = setTimeout(() => setMounted(false), MS);
    }
    return () => clearTimeout(t.current);
  }, [open]);

  return { mounted, visible };
}

export { MS };
